export default __webpack_public_path__ + "static/media/art-0-topsoil.032705ed.jpeg";